import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function useMetaPixel() {
  useEffect(() => {
    // Skip if already loaded
    if (typeof window.fbq === 'function' && window.fbq.loaded) return;
    // Defer pixel loading to not block initial render
    const loadPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2115384765696088');
      fbq('track', 'PageView');
    `;
      document.head.appendChild(script);
      // Add noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2115384765696088&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };
    // Wait for page to be interactive before loading pixel
    if (document.readyState === 'complete') {
      setTimeout(loadPixel, 1000);
    } else {
      window.addEventListener('load', () => setTimeout(loadPixel, 1000));
    }
  }, []);
}
export function trackAddToCart() {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart', {
      content_name: 'Paz Hormonal +40',
      content_type: 'product',
      value: 37,
      currency: 'USD'
    });
  }
}